import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private document = inject<Document>(DOCUMENT);

  /**
   * Scrolls smoothly to the bottom of the page.
   */
  public scrollToBottom(): void {
    this.document.documentElement.scrollTo({
      top: this.document.body.scrollHeight,
      behavior: 'smooth',
    });
  }
}
